import React from 'react';
const buttonStyles: React.CSSProperties = {
  display: 'flex',
  padding: '5px 10px',
  alignItems: 'center',
  gap: '5px',
  borderRadius: '4px',
  background: 'rgba(0, 0, 0, 0.20)',
  textDecoration: 'none',
  border: 'none',
  cursor: 'pointer',
  outline: 'none',
};

const textStyles: React.CSSProperties = {
  color: '#FFF',
  fontSize: '12px',
  fontWeight: 800,
  display: 'flex',
  alignItems: 'center',
  lineHeight: '1',
};

export const AISearchWatcherButton = () => {
  return (
    <a
      href={'/ai-search-watcher/?ref=mngls-navbar'}
      target="_blank"
      style={buttonStyles}
    >
      <svg
        width="13"
        height="17"
        viewBox="0 0 13 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: '12px',
          height: '17px',
          fill: '#FFBE02',
          display: 'flex',
          flexShrink: 0,
        }}
      >
        <path
          d="M6.90552 0C6.90552 4.4863 4.41621 8.5 0.905518 8.5C4.41621 8.5 6.90552 12.514 6.90552 17C6.90552 12.514 9.39483 8.5 12.9055 8.5C9.39483 8.5 6.90552 4.4863 6.90552 0Z"
          fill="#FFBE02"
        />
      </svg>
      <span style={textStyles}>AI Search Watcher</span>
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: '12px',
          height: '12px',
          aspectRatio: '1/1',
          display: 'flex',
          flexShrink: 0,
        }}
      >
        <g clipPath="url(#clip0_360_15795)">
          <path
            d="M11.0305 8H10.2805C10.1811 8 10.0857 8.03951 10.0154 8.10983C9.94503 8.18016 9.90552 8.27554 9.90552 8.375V11H2.40552V3.5H5.78052C5.87997 3.5 5.97536 3.46049 6.04568 3.39016C6.11601 3.31984 6.15552 3.22446 6.15552 3.125V2.375C6.15552 2.27554 6.11601 2.18016 6.04568 2.10984C5.97536 2.03951 5.87997 2 5.78052 2H2.03052C1.73215 2 1.446 2.11853 1.23502 2.3295C1.02404 2.54048 0.905518 2.82663 0.905518 3.125L0.905518 11.375C0.905518 11.6734 1.02404 11.9595 1.23502 12.1705C1.446 12.3815 1.73215 12.5 2.03052 12.5H10.2805C10.5789 12.5 10.865 12.3815 11.076 12.1705C11.287 11.9595 11.4055 11.6734 11.4055 11.375V8.375C11.4055 8.27554 11.366 8.18016 11.2957 8.10983C11.2254 8.03951 11.13 8 11.0305 8ZM12.343 0.5H9.34302C8.84216 0.5 8.59185 1.10727 8.94458 1.46094L9.782 2.29836L4.06958 8.00867C4.01714 8.06093 3.97553 8.12303 3.94714 8.1914C3.91875 8.25977 3.90414 8.33308 3.90414 8.40711C3.90414 8.48114 3.91875 8.55445 3.94714 8.62282C3.97553 8.69119 4.01714 8.75329 4.06958 8.80555L4.60091 9.33594C4.65317 9.38838 4.71526 9.42999 4.78364 9.45838C4.85201 9.48677 4.92531 9.50138 4.99935 9.50138C5.07338 9.50138 5.14668 9.48677 5.21506 9.45838C5.28343 9.42999 5.34552 9.38838 5.39778 9.33594L11.1074 3.62469L11.9446 4.46094C12.2961 4.8125 12.9055 4.56641 12.9055 4.0625V1.0625C12.9055 0.913316 12.8463 0.770242 12.7408 0.664752C12.6353 0.559263 12.4922 0.5 12.343 0.5Z"
            fill="#B0BBC5"
          />
        </g>
        <defs>
          <clipPath id="clip0_360_15795">
            <rect
              width="12"
              height="12"
              fill="white"
              transform="translate(0.905518 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </a>
  );
};

export default AISearchWatcherButton;
